module.exports = __webpack_public_path__ + "files/3ce4da6b03de42c61b63cceb9b4a46f5.png";